import * as React from 'react';
import styled from 'styled-components';

import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

const HeadingList = styled.div``;

const Container = styled.div`
  max-width: 214px;
  padding: 12px;
  border: 1px solid ${colorsV2.neutral40};
  border-radius: 16px;
  user-select: none;

  ${fromScreen(1240)} {
    border: none;
    border-radius: 0;
    padding: 0;
  }
`;

interface LandingSideInfoTableOfContentProps {
  title?: string;
  content?: {
    id?: string;
    render?: () => React.ReactNode;
  }[];
}

export const LandingSideInfoTableOfContent = (props: LandingSideInfoTableOfContentProps) => {
  const { title, content } = props;

  return (
    <Container className="landing-side-info-table-of-content">
      <ResponsiveTypography.Paragraph
        variant="semi-bold/16-24"
        color="neutral180"
        mb="12px"
        ellipsis
      >
        {title}
      </ResponsiveTypography.Paragraph>
      <HeadingList>
        {content?.map((singleContent, contentIndex) => {
          const { id, render } = singleContent;

          return <React.Fragment key={id || contentIndex}>{render?.()}</React.Fragment>;
        })}
      </HeadingList>
    </Container>
  );
};
